import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App'
import './styles/index.css'

const root = document.getElementById('root')
if (!root) throw new Error('#root is missing from index.html')

/**
 * Start the API fixtures before the first render, when they are enabled.
 *
 * `VITE_API_MOCKS` is a build-time flag, so a production bundle contains no
 * reference to `msw` at all — the dynamic import sits inside a branch Vite
 * statically eliminates. That is checked by a test rather than assumed
 * (`src/test/noMocksInProduction.test.ts`), because "it tree-shakes" is exactly
 * the sort of claim that stops being true after an unrelated refactor.
 *
 * Awaited rather than fired and forgotten: the app calls /me on mount, and a
 * worker that registers a frame later misses it.
 */
async function main() {
  if (import.meta.env.VITE_API_MOCKS === 'true') {
    if (import.meta.env.VITE_LOCAL_PREVIEW === 'true') {
      const { setupLocalPreview } = await import('./test/msw/preview')
      setupLocalPreview()
    }
    const { worker } = await import('./test/msw/browser')
    await worker.start({
      onUnhandledRequest: 'bypass',
      quiet: true,
      serviceWorker: { url: '/mockServiceWorker.js' },
    })
  }

  createRoot(root!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

void main()
